export const initialState = {
  expandedRowMapById: {}, // tracks position (idx + 1) example: { '99': 2 } maps to id:99, idx:1
  selectedSurveysArrMapById: {}, // tracks by lineagg id and holds an array of survey ids.
  isLinking: false,
  linkErrorMessage: undefined
};

export default initialState;
